import client from '../ApolloClient'
import gql from 'graphql-tag'
import { SENDTOKEN, login, logout } from '../Actions/Account'
import { failFetch, FAIL_FETCH } from '../Actions/Other'
// eslint-disable-next-line
import { Observable, Subject, filter, mergeMap, map } from 'rxjs';

const accessTokenQuery = gql`query {
  getMe {
    _id
    name
    accountId
    accountName
    logoutUrl
    logoUrl
    userAnalyticsEnabled
  }
}`

/**
  * accessTokenEpic
  * @desc action Observer that sends a query and processes result if it receives an access token action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const accessTokenEpic = action$ =>
  action$.pipe(
    filter(action => action.type === SENDTOKEN),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: accessTokenQuery })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return login(response.data.getMe)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

/**
  * fetchFailEpic
  * @desc action Observer that sends a query and processes result if a fetch fail action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const fetchFailEpic = (action$, store) =>
  action$.pipe(
    filter(action => action.type === FAIL_FETCH),
    filter(action => action.error === 'UNAUTHORIZED'),
    map(() => logout()))
